var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.change > 0)?_c('div',{staticClass:"green"},[_vm._v("+"+_vm._s(_vm.change.toFixed(1))+"%")]):(_vm.change == 0)?_c('span',[_vm._v(_vm._s(_vm.change.toFixed(1))+"%")]):_c('div',{staticClass:"red"},[_vm._v(_vm._s(_vm.change.toFixed(1))+"%")])
}
var staticRenderFns = []

export { render, staticRenderFns }